export const AWS_REGION = "us-east-2";
export const AWS_IOT_ENDPOINT = "a35ppb6r2w1mgp-ats.iot.us-east-2.amazonaws.com";
export const AWS_COGNITO_IDENTITY_POOL_ID = "us-east-2:54fb6104-8ca4-4d2e-bfe1-db012fea0759";
